var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONStruct, nullable, property } from 'badphraim/data/JSONStruct';
export class ewBoostsignupClass extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.eier = 0;
        /** @override */ this.id = 0;
    }
}
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "avdeling", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewBoostsignupClass.prototype, "avdelingnavn", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "book_inntil", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewBoostsignupClass.prototype, "booked", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewBoostsignupClass.prototype, "booked_text", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "booking", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "booking_starts_at", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewBoostsignupClass.prototype, "color", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "cost", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "cost_excluded_vat", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "dagerfor", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "dato", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "eier", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewBoostsignupClass.prototype, "error", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "free", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "gren", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewBoostsignupClass.prototype, "grennavn", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "gyldig_fra", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "gyldig_til", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "id", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewBoostsignupClass.prototype, "instructor", void 0);
__decorate([
    nullable,
    __metadata("design:type", Boolean)
], ewBoostsignupClass.prototype, "is_attending", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "klipp", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewBoostsignupClass.prototype, "lang_beskrivelse", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewBoostsignupClass.prototype, "min", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "res_slettes", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "sal", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewBoostsignupClass.prototype, "salnavn", void 0);
__decorate([
    nullable,
    __metadata("design:type", Boolean)
], ewBoostsignupClass.prototype, "skjul_antall_ledige", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "slett_vente_min", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewBoostsignupClass.prototype, "source", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewBoostsignupClass.prototype, "tema_time", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewBoostsignupClass.prototype, "tidspunkt", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewBoostsignupClass.prototype, "tim", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewBoostsignupClass.prototype, "tittel", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "varighet", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewBoostsignupClass.prototype, "waitingspot", void 0);
